import { SurveyVariant } from '@/features/course/learner/types/survey';
import { BlockId } from '@/administration/pages/Course/store/types';

export enum BlockType {
  TEXT = 'TEXT',
  RESULT = 'RESULT',
  SURVEY_RESULT = 'SURVEY_RESULT',
  QUESTION = 'QUESTION',
  PRACTICAL_ASSESSMENT_TEXT = 'PRACTICAL_ASSESSMENT_TEXT',
  PRACTICAL_ASSESSMENT_DOCUMENT = 'PRACTICAL_ASSESSMENT_DOCUMENT',
  PRACTICAL_ASSESSMENT_VIDEO = 'PRACTICAL_ASSESSMENT_VIDEO',
  REFLECTION = 'REFLECTION',
  QUIZ = 'QUIZ',
}

export type PracticalAssessmentTextBlock = {
  id: BlockId;
  type: BlockType.PRACTICAL_ASSESSMENT_TEXT;
  description: string;
  peerReviewEnabled: boolean;

  remoteId?: number;
};

export type PracticalAssessmentDocumentBlock = {
  id: BlockId;
  type: BlockType.PRACTICAL_ASSESSMENT_DOCUMENT;
  description: string;
  peerReviewEnabled: boolean;

  remoteId?: number;
};

export type PracticalAssessmentVideoBlock = {
  id: BlockId;
  type: BlockType.PRACTICAL_ASSESSMENT_VIDEO;
  description: string;
  peerReviewEnabled: boolean;

  remoteId?: number;
};

export type TextBlock = {
  id: BlockId;
  type: BlockType.TEXT;
  text: string;

  remoteId?: number;
};

export type ResultBlock = {
  id: BlockId;
  type: BlockType.RESULT;
  level: string;
  effortHours?: number;
  effortMinutes?: number;
};

export type SurveyResultBlock = {
  id: BlockId;
  type: BlockType.SURVEY_RESULT;
  variant: SurveyVariant;
};

type RadioQuestionVariant = {
  variant: 'RADIO';
  answerValue?: number;
  answerOptions: {
    order: number;
    value: number;
    title: string;
  }[];
};

type QuestionVariant = RadioQuestionVariant;

export type QuestionBlock = {
  id: BlockId;
  type: BlockType.QUESTION;
  title: string;
  description?: string;
  remoteId?: number;
} & QuestionVariant;

export type ReflectionBlock = {
  id: BlockId;
  type: BlockType.REFLECTION;
  description: string;

  sectionPath?: string[];
  postId?: number;

  remoteId?: number;
};

type QuizBlock = {
  id: BlockId;
  type: BlockType.QUIZ;
  title: string;
  text: string;
};

export type Block =
  | TextBlock
  | QuestionBlock
  | ResultBlock
  | SurveyResultBlock
  | PracticalAssessmentTextBlock
  | PracticalAssessmentVideoBlock
  | PracticalAssessmentDocumentBlock
  | ReflectionBlock
  | QuizBlock;
